/**
 * @group Telehealth
 * @summary URL path constants for telehealth API fetch calls
 *
 * @remarks
 * These are the actual HTTP paths used for client-side `fetch` / API client
 * calls. They are distinct from `ROUTE_RESOURCES` which contains RBAC
 * resource identifiers for the route-level permission system.
 *
 * @example
 * ```typescript
 * import { TELEHEALTH_API_PATHS } from '@shared/constants';
 *
 * await apiClient.post(TELEHEALTH_API_PATHS.QUEUE, {});
 * await apiClient.delete(TELEHEALTH_API_PATHS.QUEUE_BY_ID(consultationId));
 * await apiClient.get(TELEHEALTH_API_PATHS.QUEUE_STATUS(consultationId));
 * await apiClient.post(TELEHEALTH_API_PATHS.JOIN, { joinTicket });
 * ```
 */
export const TELEHEALTH_API_PATHS = {
  QUEUE: '/api/telehealth/queue',
  QUEUE_BY_ID: (consultationId: string) =>
    `/api/telehealth/queue/${consultationId}`,
  QUEUE_STATUS: (consultationId: string) =>
    `/api/telehealth/queue/${consultationId}/status`,
  JOIN: '/api/telehealth/join',
} as const;
